export const colors = [
  {
    name: 'Black',
    color: 'black',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/black_f5854ec7-e61b-4beb-bffb-6855f22bcf0b.jpg'
      }
    ]
  },
  {
    name: 'Grey',
    color: 'grey',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/grey.jpg'
      }
    ]
  },
  {
    name: 'Smoke',
    color: 'smoke',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/smoke.jpg'
      }
    ]
  },
  {
    name: 'Beige',
    color: 'beige',
    images: [
      {
        type: 'swatch',
        imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/beige_1f9dcb99-1394-4033-be83-80a41f01510e.jpg'
      }
    ]
  }
];
